module.exports = __webpack_public_path__ + "static/db1000-2d51993f4ca159c89534902f9f04802d.png";